<!-- 核心结果 -->
<template>
  <div class="page_part5">
    <!-- 第一页-->
    <div class="page_shadow page_main">
      <!-- <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader> -->
        <div class="buchongs">
          <!-- <a>报告解读：</a> -->
          <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="isDisabled"
                type="textarea"
                maxlength="200"               
                show-word-limit
                v-model="reliabilityIndex">
            </el-input>
          </div>
        </div>
      <template>
        <h5 class="header page_header">
          <span>Part.{{ partIndex }} 核心结果</span>
        </h5>
        <h6 class="page_title_2">
          <span>核心结果总览</span>
          <span class="arrow"></span>
        </h6>
      </template>
      <!-- 学习力总体-->
      <div>
        <p class="page_title_3_0">
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习力总体得分
        </p>
        <template v-if="isFinishPart123">
          <p class="part_detail">
            你的学习力总体得分为：<span :class="getCorlor(total.score)">{{
              total.score | toFixed(1)
            }}</span
            >分， 整体水平为：<span :class="getCorlor(total.score)">{{
              total.result
            }}</span
            >， 超过<span :class="getCorlor(total.score)"
              >{{ (total.percent * 100) | toFixed(1) }}%</span
            >的人。
          </p>
          <div
            class="lis_score_box psychology"
            :style="{ width: '712px', marginLeft: '-10px' }"
          >
            <ul class="lis_score lis_psy">
              <li>
                <p class="name">
                  {{ total.name }}
                </p>
                <div class="li_score_box">
                  <div class="box">
                    <div
                      class="score"
                      :class="[getBgColor1(total.score)]"
                      :style="{ width: (total.score / 200) * 600 + 'px' }"
                    ></div>
                    <p
                      class="comment"
                      :style="{ left: (total.score / 200) * 600 - 40 + 'px' }"
                    >
                      <span>{{ total.score | toFixed(1) }}</span>
                      <span :class="getCorlor(total.score)"
                        >[{{ total.result }}]</span
                      >
                    </p>
                    <div
                      class="norm"
                      :style="{
                        left: (normData.l_norm / 200) * 600 + 'px',
                        width:
                          ((normData.r_norm - normData.l_norm) / 200) * 600 +
                          'px',
                      }"
                    ></div>
                  </div>
                </div>
              </li>
              <li>
                <p class="name">
                  {{ part1Total.name }}
                </p>
                <div class="li_score_box">
                  <div class="box">
                    <div
                      class="score"
                      :class="[getBgColor1(part1Total.score)]"
                      :style="{ width: (part1Total.score / 200) * 600 + 'px' }"
                    ></div>
                    <p
                      class="comment"
                      :style="{
                        left: (part1Total.score / 200) * 600 - 40 + 'px',
                      }"
                    >
                      <span>{{ part1Total.score | toFixed(1) }}</span>
                      <span :class="getCorlor(part1Total.score)"
                        >[{{ part1Total.result }}]</span
                      >
                    </p>
                    <div
                      class="norm"
                      :style="{
                        left: (normData.l_norm / 200) * 600 + 'px',
                        width:
                          ((normData.r_norm - normData.l_norm) / 200) * 600 +
                          'px',
                      }"
                    ></div>
                  </div>
                </div>
              </li>
              <li>
                <p class="name">
                  {{ part3Total.name }}
                </p>
                <div class="li_score_box">
                  <div class="box">
                    <div
                      class="score"
                      :class="[getBgColor1(part3Total.score)]"
                      :style="{ width: (part3Total.score / 200) * 600 + 'px' }"
                    ></div>
                    <p
                      class="comment"
                      :style="{
                        left: (part3Total.score / 200) * 600 - 40 + 'px',
                      }"
                    >
                      <span>{{ part3Total.score | toFixed(1) }}</span>
                      <span :class="getCorlor(part3Total.score)"
                        >[{{ part3Total.result }}]</span
                      >
                    </p>
                    <div
                      class="norm"
                      :style="{
                        left: (normData.l_norm / 200) * 600 + 'px',
                        width:
                          ((normData.r_norm - normData.l_norm) / 200) * 600 +
                          'px',
                      }"
                    ></div>
                  </div>
                </div>
              </li>
              <li>
                <p class="name">
                  {{ part2Total.name }}
                </p>
                <div class="li_score_box">
                  <div class="box">
                    <div
                      class="score"
                      :class="[getBgColorDongli(part2Total.score)]"
                      :style="{ width: (part2Total.score / 200) * 600 + 'px' }"
                    ></div>
                    <p
                      class="comment"
                      :style="{
                        left: (part2Total.score / 200) * 600 - 40 + 'px',
                      }"
                    >
                      <span>{{ part2Total.score | toFixed(1) }}</span>
                      <span :class="getCorlorDongli(part2Total.score)"
                        >[{{ part2Total.result }}]</span
                      >
                    </p>
                    <div
                      class="norm"
                      :style="{
                        left:
                          (normDataDongli.l_norm / 200) * 600 +
                          'px',
                        width:
                          ((normDataDongli.r_norm -
                            normDataDongli.l_norm) /
                            200) *
                            600 +
                          'px',
                      }"
                    ></div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="rule_box">
              <p class="name"><span>0</span></p>
              <ul class="rule">
                <li
                  v-for="item in [20, 40, 60, 80, 100, 120, 140, 160, 180, 200]"
                >
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="buchongs">
        <!-- <a>报告解读：</a> -->
        <div class="textare">
            <el-input
                placeholder="咨询师解读"
                :disabled="isDisabled"
                type="textarea"
                maxlength="200"               
                show-word-limit
                v-model="learningAbility"
                
                >
            </el-input>
        </div>
      </div>

        </template>
        <!-- <template v-else>
          <div class="lis_score_box" :style="{ height: '270px' }">
            测评未完成，测评完成后展示该部分内容！
          </div>
        </template> -->
      </div>
      
      <!--学习潜力-->
      <template v-if="part1Data.test_id">
        <p class="arrow_box">学习潜力<span class="arrow"></span></p> 
        <p class="page_title_3_0">
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习潜力得分
        </p>
        <p class="part_detail">
          你的{{ part1Total.name }}总体得分为：<span
            :class="getCorlor(part1Total.score)"
            >{{ part1Total.score | toFixed(1) }}</span
          >分， 整体水平为：<span :class="getCorlor(part1Total.score)">{{
            part1Total.result
          }}</span
          >， 超过<span :class="getCorlor(part1Total.score)"
            >{{ (part1Total.percent * 100) | toFixed(1) }}%</span
          >的人。
        </p>
        <div class="echartsBox" style="margin-top:-20px;margin-bottom:45px">
          <div class="normBox1"></div>
          <div
            id="echart_qianli"
            :style="{ width: '710px', height: '420px' }"
          ></div>
        </div>
        <div class="buchongs">
            <!-- <a>报告解读：</a> -->
            <div class="textare">
                <el-input
                    placeholder="咨询师解读"
                    :disabled="isDisabled"
                    type="textarea"
                    maxlength="200"               
                    show-word-limit
                    v-model="learningPotential"
                    >
                </el-input>
            </div>
        </div>
      </template>
      <!-- <p class="big_page_number"></p>            -->
    </div>
    <!--第二页 学习效力得分 -->
    <div class="page_shadow page_main" v-if="part3Data.test_id">
      <!-- <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader> -->
      <!-- 学习策略 -->
      <template>
        <p class="arrow_box">学习效力<span class="arrow"></span></p>
        <p class="page_title_3_0">
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习效力-学习策略得分
        </p>
        <p class="part_detail">
          你的学习策略总体平均得分为：<span
            :class="getCorlor(part3Total.score)"
            >{{ part3Total.score | toFixed(1) }}</span
          >分， 整体水平为：<span :class="getCorlor(part3Total.score)">{{
            part3Total.result
          }}</span
          >， 超过<span :class="getCorlor(part3Total.score)"
            >{{ (part3Total.percent * 100) | toFixed(1) }}%</span
          >的人。
        </p>
        <div class="echartsBox" :style="{ marginBottom: '40px' }">
          <div class="normBox1"></div>
          <div
            id="echart_celve"
            :style="{ width: '710px', height: '420px' }"
          ></div>
        </div>
        <div class="buchongs" style="margin-top:45px">
                <!-- <a>报告解读：</a> -->
                <div class="textare">
                    <el-input
                        placeholder="咨询师解读"
                        :disabled="isDisabled"
                        type="textarea"
                        maxlength="200"               
                        show-word-limit
                        v-model="learningStrategy"
                        >
                    </el-input>
                </div>
      </div>
      </template>
      <!-- 学习风格 -->
      <template>
        <p class="page_title_3_0" >
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习效力-学习风格得分
        </p>
        <p class="part_detail">
            你的学习风格更倾向于：<span style="color:#2CABBB">{{styleNorm[2].result}}</span>。
        </p>
        <div class="flex_box">
            <span>认知风格</span>
            <div class="div1">
                <div class="item1">整体型</div>
                <div class="item2" :class="styleNorm[2].result=='梗概型'?'active_style':''">梗概型</div>
                <div class="item3" :class="styleNorm[2].result=='布局型'?'active_style':''">布局型</div>
            </div>
            <div class="div1">
                <div class="item1">具体型</div>
                <div class="item2" :class="styleNorm[2].result=='散漫型'?'active_style':''">散漫型</div>
                <div class="item3" :class="styleNorm[2].result=='游击型'?'active_style':''">游击型</div>
                
            </div>
            <div class="xingdong">行动风格</div>
            <div class="flex_bottom">
                <div style="padding-left:50px">拖延型</div>
                <div>推动型</div>            
            </div>
        </div>        
      </template>
      <!-- <p class="big_page_number"></p> -->
      <div class="buchongs" style="margin-top:45px">
                <!-- <a>报告解读：</a> -->
                <div class="textare">
                    <el-input
                        placeholder="咨询师解读"
                        :disabled="isDisabled"
                        type="textarea"
                        maxlength="200"               
                        show-word-limit
                        v-model="learningStyle"
                        >
                    </el-input>
                </div>
      </div>
    </div>
    <!-- 第三页 -->
    <div
      class="page_shadow page_main page_fenxi"
      v-if="part2Data.test_id">
       <!-- <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader> -->
       <template v-if="part2Data.test_id">
         <p class="arrow_box">学习动力<span class="arrow"></span></p>
         <p class="page_title_3_0" style="margin-bottom:10px">
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习动力-学习态度得分
         </p>
         <p class="part_detail" style="margin-bottom:0;padding-top:0">
          你的学习态度总体平均得分为：<span
            :class="getCorlorDongli(part2Total.attitude.score)"
            >{{ part2Total.attitude.score | toFixed(1) }}</span
          >分， 整体水平为：<span :class="getCorlorDongli(part2Total.attitude.score)">{{
            part2Total.attitude.result
          }}</span
          >，超过<span :class="getCorlor(part2Total.attitude.score)">{{(part2Total.attitude.percent * 100) | toFixed(1) }}%</span>的人。
        </p>
        <div class="page_part2_result ">
          <div
            :class="['detail_box', 'detail_box' + index]"
            v-for="(item, index) in part2norm.attitude.child||[]"
            :key="index"
            v-if="index < 3"
          >
            <p class="title"><span></span>{{ item.name }}</p>
            <p class="score">
              水平值：<span>{{ item.score | toFixed(1) }}</span>
            </p>
            <p class="score">
              评价：<span :class="[getCorlorDongli(item.score)]">{{ item.result }}</span>
            </p>
          </div>
          <div class="circle_box">
            <div class="topBox"></div>
            <div class="middleBox">
              <div
                :class="['norm_box', 'norm_' + item.type]"
                v-for="(item, index) in part2norm.attitude.child||[]"
                :key="index"
                v-if="index < 3"
              >
                <div class="norm">
                  <div
                    class="norm_child"
                    v-if="item.type == 'qinggan'"
                    :style="{
                      left:
                        ((normDataDongli.l_norm - 1) / 200) * 180 +
                        'px',
                      width:
                        ((normDataDongli.r_norm -
                          normDataDongli.l_norm) /
                          200) *
                          180 +
                        'px',
                    }"
                  ></div>
                  <div
                    class="norm_child"
                    v-if="item.type == 'renzhi'"
                    :style="{
                      left:
                        ((normDataDongli.l_norm - 1) / 200) * 180 + 'px',
                      width:
                        ((normDataDongli.r_norm -
                          normDataDongli.l_norm) /
                          200) *
                          180 +
                        'px',
                    }"
                  ></div>
                  <div
                    class="norm_child"
                    v-if="item.type == 'xingwei'"
                    :style="{
                      left:
                        ((normDataDongli.l_norm - 1) / 200) * 180 +
                        'px',
                      width:
                        ((normDataDongli.r_norm -
                          normDataDongli.l_norm) /
                          200) *
                          180 +
                        'px',
                    }"
                  ></div>
                  <div class="norm_bg"></div>
                  <div
                    class="score"
                    :style="{ left: (item.score * 180) / 200 - 2.5 + 'px' }"
                    :title="item.score | toFixed(1)"
                  >
                    <span>{{ item.score | toFixed(1) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottomBox">
              <p class="title"><span></span>{{part2norm.attitude.name}}</p>
              <p class="score">
                水平值：<span>{{ part2norm.attitude.score | toFixed(1) }}</span>
              </p>
              <p class="score">
                评价：<span>{{ part2norm.attitude.result }}</span>
              </p>
            </div>
          </div>
        </div>
       </template>
       <template v-if="part2Data.test_id">
        <p class="page_title_3_0" >
           <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习动力-学习动机得分
        </p>
        <p class="part_detail" style="margin-bottom:0">
          你的学习动机主要类型为：
          <span style="color:#2CABBB" :index='index' v-for="item,index in part2Total.motive.motive_result||[]" :key="index">
              {{item.name}}<b v-if="index!== part2Total.motive.motive_result.length-1">、</b>
          </span>。你的动机强度为：<span :class="getCorlor(part2Total.motive.score)">{{part2Total.motive.score | toFixed(1)}}</span>分，
          超过<span :class="getCorlor(part2Total.motive.score)">{{(part2Total.motive.percent * 100) | toFixed(1) }}%</span>的人。
        </p>
        <div class="echartsBox" :style="{ marginBottom: '70px',marginTop:'-22px' }">
          <div class="normBox1 normBoxdongji"></div>
          <div
            id="echart_dongji"
            :style="{ width: '710px', height: '390px' }"
          ></div>
        </div>
       </template>
       <!-- <p class="big_page_number"></p> -->
        
    </div>
    <!-- 第四页 -->
    <div class="page_shadow page_main" v-if="part2Data.test_id || part4Data.test_id">
      <!-- <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader> -->
      <template v-if="part2Data.test_id">
        <p class="page_title_3_0" >
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          学习动力-学习效能感得分
        </p>
        <p class="part_detail">
          你的{{ part2Total.efficacy.name }}总体平均得分为：<span
            :class="getCorlorDongli(part2Total.efficacy.score)"
            >{{ part2Total.efficacy.score | toFixed(1) }}</span
          >分， 整体水平为：<span :class="getCorlorDongli(part2Total.efficacy.score)">{{
            part2Total.efficacy.result
          }}</span>，超过<span :class="getCorlor(part2Total.efficacy.score)"
            >{{ (part2Total.efficacy.percent * 100) | toFixed(1) }}%</span
          >的人。
        </p>
        <div
            class="lis_score_box psychology"
            :style="{ width: '712px', marginLeft: '-10px' }"
        >
          <ul class="lis_score lis_psy">
              <li v-for="item,index in part2Total.efficacy.child">
                  <p class="name">
                  {{ item.name }}
                </p>
                <div class="li_score_box" style="width:580px">
                  <div class="box">
                    <div
                      class="score"
                      :class="[getBgColor1(item.score)]"
                      :style="{ width: (item.score / 200) * 600 + 'px' }"
                    ></div>
                    <p
                      class="comment"
                      :style="{ left: (item.score / 200) * 600 - 40 + 'px' }"
                    >
                      <span>{{ item.score | toFixed(1) }}</span>
                      <span :class="getCorlor(item.score)"
                        >[{{ item.result }}]</span
                      >
                    </p>
                    <div
                      class="norm"
                      :style="{
                        left: (normData.l_norm / 200) * 600 + 'px',
                        width:
                          ((normData.r_norm - normData.l_norm) / 200) * 600 +
                          'px',
                      }"
                    ></div>
                  </div>
                </div>
              </li>
          </ul>
          <div class="rule_box">
              <p class="name"><span>0</span></p>
              <ul class="rule" style="width:580px">
                <li
                  v-for="item in [20, 40, 60, 80, 100, 120, 140, 160, 180, 200]"
                >
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
        </div>
      </template>
      <div class="buchongs">
                <!-- <a>报告解读：</a> -->
                <div class="textare">
                    <el-input
                        placeholder="咨询师解读"
                        :disabled="isDisabled"
                        type="textarea"
                        maxlength="200"               
                        show-word-limit
                        v-model="learningMotivation"
                        >
                    </el-input>
                </div>
        </div>
      <template v-if="part4Data.test_id && (isXljkReport == 0 || !isXljkReport)">
        <p class="arrow_box">心理风险<span class="arrow"></span></p>
        <p class="page_title_3_0">
          <img src="~@/assets/report2_imgs/icon_fc.png" alt="" />
          心理风险得分
        </p>
        <p class="part_detail">
          你的心理风险总体平均得分为：<span
            :style="{ color: getCorlorGrade(part4norm[6].score) }"
            >{{ part4norm[6].score }}</span
          >分， 整体水平为：<span
            :style="{ color: getCorlorGrade(part4norm[6].score) }"
            >{{ part4norm[6].result}}</span
          >。
        </p>
        <div class="lis_score_box psychology" :style="{ width: '712px'}">
          <ul class="lis_score lis_psy">
            <li v-for="(item, index) in part4norm.slice(0,6)" :key="index">
              <p class="name">
                {{ item.name }}
              </p>
              <div class="li_score_box">
                <div class="box">
                  <div
                    class="score"
                    :class="[getBgColor(item.name,item.score)]"
                    :style="{ width: (item.score / 5) * 600 + 'px' }"
                  ></div>
                  <p
                    class="score_comment"
                    :style="{ left: (item.score / 5) * 600 - 30 + 'px' }"
                  >
                    {{ item.score | toFixed(1) }}
                  </p>
                  
                  <div
                    class="norm"
                    :style="{
                      left: (normDataMind[item.type].l_norm / 5) * 600 + 'px',
                      width:
                        ((normDataMind[item.type].r_norm -
                          normDataMind[item.type].l_norm) /
                          5) *
                          600 +
                        'px',
                    }"
                  ></div>
                </div>
              </div>
            </li>
          </ul>
          <div class="rule_box">
            <p class="name"><span>0</span></p>
            <ul class="rule">
              <li v-for="item in 5">
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="buchongs" style="padding-bottom:45px">
                <!-- <a>报告解读：</a> -->
                <div class="textare">
                    <el-input
                        placeholder="咨询师解读"
                        :disabled="isDisabled"
                        type="textarea"
                        maxlength="200"               
                        show-word-limit
                        v-model="mind"
                        >
                    </el-input>
                </div>
        </div>
      </template>
      <!-- <p class="big_page_number"></p> -->
      
    </div>
    <div>  
          <div>
            <ul class="bottom">
              <div  style="margin:0 auto" class="button hover" v-if="is_return"  @click="$router.go(-1)" >返回</div>
              <div style="margin:0 auto" class="button hover" v-if="is_btn" @click="return_btn()">返回修改</div>
              <div  style="margin:0 auto" class="button hover" @click="submit()" v-if="is_btn">提交</div>

            </ul>
          </div>
        </div>
  </div>
</template>
<script>
export default {
  name: "page_part5",
  props: {
    // 报告解读显示
    // reliabilityIndex:{},
    // learningAbility:{},
    // learningPotential:{},
    // learningStrategy:{},
    // learningStyle:{},
    // learningMotivation:{},
    // mind:{},

    headerLogo: {},
    isFinishAll: {},
    isFinishPart123: {},
    core: {},
    normData: {},
    normDataDongli: {},
    normDataMind: {
      type: Object,
    },
    partIndex: {},
    //学习力总体
    total: {
      type: Object | Array,
    },
    //学习潜力总体
    part1Total: {
      type: Object,
    },
    //学习动力总体
    part2Total: {
      
      
        type: Object,
      
    },
    //学习效力总体
    part3Total: {
      type: Object,
    },
    part1Norm: {},
    part2norm: {},
    part2comment: {},
    part3StrategyNorm: {},

    part1Data: {},
    part2Data: {},
    part3Data: {},
    part3Strategy: {},
    part3style: {},
    part4Data: {},

    styleNorm: {
      type: Array,
    },
    styleComment: {
      type: Object,
    },
    part2:{}
  },
  data() {
    return {
      isXljkReport: sessionStorage.getItem("isXljkReport"),
      reliabilityIndex:'',
      learningAbility:'',
      learningPotential:'',
      learningStrategy:'',
      learningStyle:'',
      learningMotivation:'',
      mind:'', //心理风险得分:
      isDisabled:false,
      is_btn:true, // 提交按钮默认展示
      is_return:false, //返回按钮默认不展示
    };
  },
  computed: {
      
    part1NormSort() {
        let arr = [];
        let part1Norm = this.part1Norm;
        if (part1Norm.length) {
            arr[0] = part1Norm[0];
            arr[1] = part1Norm[1];
            arr[2] = part1Norm[2];
            arr[3] = part1Norm[3];
            arr[4] = part1Norm[4];
            arr[5] = part1Norm[5];
            arr[6] = part1Norm[6];
            arr[7] = part1Norm[7];
            arr[8] = part1Norm[8];
            arr[9] = part1Norm[9];
        }
      return arr;
    },
    part3StrategyNormSort() {
      let arr = [];
      let part3Norm = this.part3StrategyNorm;
      if (part3Norm.length) {
        arr[0] = part3Norm[0];
        arr[1] = part3Norm[1];
        arr[2] = part3Norm[2];
        arr[3] = part3Norm[3];
        arr[4] = part3Norm[4];
        arr[5] = part3Norm[5];
        arr[6] = part3Norm[6];
        arr[7] = part3Norm[7];
        arr[8] = part3Norm[8];
        arr[9] = part3Norm[9];
        arr[10] = part3Norm[10];
      }
      return arr;
    },
    part4norm() {
      if (this.part4Data.constructor === Object) {
        return this.part4Data.norm;
      } else {
        return null;
      }
    },
    part4normSort() {
      let arr = [];
      if (this.part4norm) {
        let norm = this.part4norm;
        arr[0] = norm.qiangpo;
        arr[1] = norm.mingan;
        arr[2] = norm.yiyu;
        arr[3] = norm.jiaolv;
        arr[4] = norm.didui;
        arr[5] = norm.pizhi;
      }
      return arr;
    },
  },
  watch: {},
  created() {},
  mounted() {  
        this.get_edit()  

        let part1NormSort = this.part1NormSort;
        let part3StrategyNorm = this.part3StrategyNormSort;
        // console.log(this.part2Total)
        if(this.part2Total){        
          this.setEcharts(this.part2Total.motive.child || [], "echart_dongji");
        }
        
        if (part1NormSort.length) {
            this.setEcharts(part1NormSort,"echart_qianli");
        }
        if (part3StrategyNorm.length) {
            this.setEcharts(part3StrategyNorm, "echart_celve");
        }   
  },
  methods: {
    return_btn(){
            this.is_return = false
            this.isDisabled = false
            this.is_btn = true;
            this.returnTop();           
        },
        returnTop(){
            $("html,body").animate({
                    scrollTop: 0
            }, 0);
        },
    get_edit(){
        this.$ajax
        .post(
          this.G_acapi + "/consultantNewStudent/getLearningCapacityInterpretation",
          {
           studentId:window.sessionStorage.getItem("myStudentStudentId"),
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
            console.log(res,'报告解读必填')
            if(res.data.data.length!=0){
              let data = res.data.data;
              this.reliabilityIndex = data.reliabilityIndex
              this.learningAbility = data.learningAbility
              this.learningPotential = data.learningPotential
              this.learningStrategy = data.learningStrategy
              this.learningStyle = data.learningStyle
              this.learningMotivation = data.learningMotivation
              this.mind = data.mind
              this.is_return = true
              this.isDisabled = true
              this.is_btn = false
            }else{
              this.is_return = false
              this.isDisabled = false
              this.is_btn = true

              
            }
        })
    },
    submit(){
            
            this.$ajax
            .post(
            this.G_acapi + "/consultantNewStudent/storeLearningCapacityInterpretation",
            {
              studentId:window.sessionStorage.getItem("myStudentStudentId"),
              reliabilityIndex:this.reliabilityIndex,
              learningAbility:this.learningAbility,
              learningPotential:this.learningPotential,
              learningStrategy:this.learningStrategy,
              learningStyle:this.learningStyle,
              learningMotivation:this.learningMotivation,
              mind:this.mind
            },
            {
                headers: {
                  token: window.sessionStorage.getItem("ymtxToken"),
                },
            }
            )
            .then((res) => {
                if(res.data.code==2000){
                    this.is_return = true
                    this.isDisabled = true
                    this.is_btn = false                   
                }else{
                    this.$message({
                    message: res.data.msg,
                    type: 'error'
                    });
                }
            })
    },
    getScore(value) {
      // 83.125,116.875
      if (value < 83.125) {
        return "score1";
      } else if (value < 116.875) {
        return "score2";
      } else {
        return "score3";
      }
    },
    setEcharts(normData, id) {
      let xAxisData = [];
      let seriesData = [];
      let colorList = [];
      normData.forEach((value, index) => {
        xAxisData.push(value.name);
        seriesData.push(Number(value.score.toFixed(1)));
        colorList.push(this.getEchartCorlor(value.score));
      });
      this.createEcharts(xAxisData, seriesData, colorList, id);
    },
    getEchartCorlor(value) {
      if (0 < value && value < 75) {
        return "#FF0000";
      } else if (75 <= value && value < 92) {
        return "#FFC001";
      } else if (92 <= value && value < 108) {
        return "#1CA4B6";
      } else if (108 <= value && value < 125) {
        return "#92D050";
      } else {
        return "#00B050";
      }
    },
    getBgColor1(value) {
      if (0 < value && value < 75) {
        return "bg_color1";
      } else if (75 <= value && value < 92) {
        return "bg_color2";
      } else if (92 <= value && value < 108) {
        return "bg_color3";
      } else if (108 <= value && value < 125) {
        return "bg_color4";
      } else {
        return "bg_color5";
      }
    },
    getBgColor(name, value) {
      let normObj = {
        强迫症状: [0, 1.38, 2.82, 3, 4, 5],
        人际关系敏感: [0, 1.04, 2.5, 3, 4, 5],
        抑郁: [0, 1.06, 2.84, 3, 4, 5],
        焦虑: [0, 1.06, 2.44, 3, 4, 5],
        敌对: [0, 1.07, 2.55, 3, 4, 5],
        偏执: [0, 1.06, 2.42, 3, 4, 5],
      };
      let normArr = [];
      if (name == "强迫症状") {
        normArr = normObj.强迫症状;
        // 
      } else if (name == "人际关系敏感") {
        normArr = normObj.人际关系敏感;
      } else if (name == "抑郁") {
        normArr = normObj.抑郁;
      } else if (name == "焦虑") {
        normArr = normObj.焦虑;
      } else if (name == "敌对") {
        normArr = normObj.敌对;
      } else if (name == "偏执") {
        normArr = normObj.偏执;
      }
      
      if (normArr[0] < value && value < normArr[1]) {
        return "c_mind1";
      } else if (normArr[1] <= value && value < normArr[2]) {
        return "c_mind2";
      } else if (normArr[2] <= value && value < normArr[3]) {
        return "c_mind3";
      } else if (normArr[3] <= value && value < normArr[4]) {
        return "c_mind4";
      } else {
        return "c_mind5";
      }
    },
    getCorlorGrade(value) {
      // num1: 1.1
      // num2: 2.6
      // num3: 3
      // num4: 4
      if (value < 1.1) {
        return "#00B050";
      } else if (value < 2.6) {
        return "#92D050";
      } else if (value < 3) {
        return "#F6A724";
      } else if (value < 4) {
        return "#FF0000";
      } else {
        return "#D50203";
      }
    },

    getCorlor(value) {
      if (0 < value && value < 75) {
        return "color1";
      } else if (75 <= value && value < 92) {
        return "color2";
      } else if (92 <= value && value < 108) {
        return "color3";
      } else if (108 <= value && value < 125) {
        return "color4";
      } else {
        return "color5";
      }
    },
    getCorlorDongli(value) {
      if (0 < value && value < 75) {
        return "color1";
      } else if (75 <= value && value < 92) {
        return "color2";
      } else if (92 <= value && value < 108) {
        return "color3";
      } else if (108 <= value && value < 125) {
        return "color4";
      } else {
        return "color5";
      }
    },
    getBgColorDongli(value) {
      if (0 < value && value < 75) {
        return "bg_color1";
      } else if (75 <= value && value < 92) {
        return "bg_color2";
      } else if (92 <= value && value < 108) {
        return "bg_color3";
      } else if (108 <= value && value < 125) {
        return "bg_color4";
      } else {
        return "bg_color5";
      }
    },
    getGradeDongli(value) {
      if (0 < value && value < 40) {
        return "低";
      } else if (40 <= value && value < 80) {
        return "较低";
      } else if (80 <= value && value < 120) {
        return "中等";
      } else if (120 <= value && value < 160) {
        return "较高";
      } else {
        return "高";
      }
    },
    getGradeMind(value) {
      if (value < 1.1) {
        return "低";
      } else if (value < 2.6) {
        return "较低";
      } else if (value < 3) {
        return "中等";
      } else if (value < 4) {
        return "较高";
      } else {
        return "高";
      }
    },
    getGrade(value) {
      if (0 < value && value < 75) {
        return "低";
      } else if (75 <= value && value < 92) {
        return "较低";
      } else if (92 <= value && value < 108) {
        return "中等";
      } else if (108 <= value && value < 125) {
        return "较高";
      } else {
        return "高";
      }
    },
    createEcharts(xAxisData, seriesData, colorList, id) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById(id));
      // 指定图表的配置项和数据
      var option = {
        // title: {
        //     text: '分值'
        // },
        tooltip: {},
        // legend: {
        //     data:[]
        // },
        xAxis: {
          type: "category",
          // data: ['注意力','信息加工能力','工作记忆能力','思维转换能力','逻辑推理能力','数学能力','表象能力','空间能力','语言能力'],
          data: xAxisData,
          axisLabel: {
            // interval: 0,
            rotate: 45,
            color: "#333",
          },
        },
        yAxis: {
          max: 200,
          splitNumber: 10,
          // Interval: 1,
          type: "value",
          name: "分值",
        },
        series: [
          {
            name: "",
            type: "bar",
            // data: [115,107,102,130,89,125,61,122,106],
            data: seriesData,
            itemStyle: {
              normal: {
                //这里是重点
                color: function (params) {
                  // console.log(colorList)
                  //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                  // var colorList = ['#71B15B','#2E75B6', '#3E9B7C', '#ECAC5C'];
                  return colorList[params.dataIndex];
                },
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 14,
                  },
                },
              },
            },
            label: {
              show: true,
              color: "#fff",
            },
          },
        ],

        barCategoryGap: "60%",
        // color: '#2c8ffc'
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    
  },
};
</script>
<style type="text/css" lang='less' scoped>
@import "./report.less";
.bottom{
    width: 400px;
    margin: 40px auto 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 14px;
    div{
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        cursor: pointer;
        background: #ecf8fe;
        color: #1ea2ee;
        border: 1px solid #76c6f4;
        display: inline-block;
        padding: 0 20px;
    }
}
.page_part2_result{
  padding-top:78px;
}
.page_part2_result .detail_box .score span.color1{
  color: #FF0000
}
.page_part2_result .detail_box .score span.color2{
  color: #FFC001
}
.page_part2_result .detail_box .score span.color3{
  color: #1CA4B6
}
.page_part2_result .detail_box .score span.color4{
  color: #92D050
}
.page_part2_result .detail_box .score span.color5{
  color: #00B050
}

.arrow_box{
  display: flex;
  align-items: center;
  line-height: 32px;
 font-size: 20px;
 font-weight: bold;
 margin-bottom: 10px;
}
// .echartsBox{
//   margin-top: -50px;
// }
.arrow{
    display:inline-block;
    margin-left: 10px;
    width: 0;

    height: 0;
    border-top: 9px solid transparent;
    border-left: 14px solid #FEAE3B;
    border-bottom: 9px solid transparent;
}
.flex_bottom{
    display: flex;
    justify-content:center;
    padding-left: 50px;

    > div{
        // flex: 1;
        text-align: center;
        box-sizing: border-box;
        width: 230px;
    }
    
}
.flex_box{
    > span{
        font-size: 14px;
        padding-left:124px;
    }
    .xingdong{
      text-align: right;
    margin-top: -22px;
    font-size: 14px;
    /* margin-right: -25px; */
    padding-right: 74px;
    }
    .div1{
        display: flex;
        justify-content: center;
        align-items: center;
        >div{
            margin-bottom: 6px;

        }
        .item2,.item3{
            width: 230px;
            height: 140px;
            background: #F6F6F6;
            text-align: center;
            line-height: 177px;
            font-size: 34px;
            color: #2CABBB;
            margin-left: 6px;

        }
        .active_style{
            background: #2CABBB;
            color: #fff;
        }
    }
    
}
.page_part5 {
  .part_detail {
    line-height: 32px;
    margin-bottom: 20px;
    span {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .echartsBox {
    position: relative;
    .normBox1 {
      position: absolute;
      width: 566px;
      height: 77px;
      left: 72px;
      bottom: 171px;
      background: rgba(121, 119, 119, 0.49);
      opacity: 0.5;
    }
    .normBox1.normBoxdongji{
      height: 68px;
      left: 72px;
      bottom: 161px;
    }
  }
  .score_line_box {
    margin-top: 55px;
    display: flex;
    height: 20px;
    line-height: 20px;
    width: 480px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    position: relative;
    .score {
      //[83.125,116.875]
      position: absolute;
      top: -36px;
      margin-left: -40px;
      width: 80px;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      background-color: #ffb91a;
      color: #333;
      border-radius: 3px;
      &:before {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        margin-left: -5px;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 10px solid #ffb91a;
      }
    }
    .score1 {
      left: 80px;
      background-color: #aacf00;
      &:before {
        border-top: 10px solid #aacf00;
      }
    }
    .score2 {
      left: 240px;
      background-color: #f6a724;
      &:before {
        border-top: 10px solid #f6a724;
      }
    }
    .score3 {
      left: 400px;
      background-color: #2cabbb;
      &:before {
        border-top: 10px solid #2cabbb;
      }
    }
    .td_p1 {
      //83.125/200*480
      flex: 1;
      height: 20px;
      line-height: 20px;
      background-color: #aacf00;
      border-radius: 10px 0 0 10px;
    }
    .td_p2 {
      height: 20px;
      line-height: 20px;
      flex: 1;
      background-color: #f6a724;
    }
    .td_p3 {
      height: 20px;
      line-height: 20px;
      flex: 1;
      background-color: #2cabbb;
      border-radius: 0 10px 10px 0;
    }
  }
  .table_box {
    padding-bottom: 60px;
    color: #333;
    tr {
      .c_line {
        background-color: #41cbaa;
      }
      .c_linec {
        background-color: #f08c00;
      }
      .c_line {
        background-color: #e7a53c;
      }

      th {
        color: #fff;
        font-size: 16px;
        background-color: #41cbaa;
        border: 1px solid #fff;
        width: 36px;
        height: 137px;
        text-align: center;
        border-radius: 6px;
      }
      .th_1 {
        background-color: #1ca4b6;
      }
      .th_2 {
        background-color: #aacf00;
      }
      .th_3 {
        background-color: #f6a724;
      }
      td {
        font-size: 14px;
        height: 84px;
        text-align: center;
        background-color: #f7f7f7;
        border: 1px solid #fff;
        .title {
          margin-bottom: 10px;
        }
        .detail {
          color: #f6a724;
          font-size: 18px;
          font-weight: bold;
          padding-bottom: 30px;
        }
      }
      .titleBox {
        padding-left: 26px;
        text-align: left;
      }
      .td_score_box {
        width: 480px;
        padding: 0 20px;
        padding-bottom: 20px;
        .title {
          text-align: left;
          margin-bottom: 50px;
        }
      }
    }
  }
  .page_title_2 {
    .arrow {
      border-left: 14px solid #feae3b;
    }
  }
  .page_part5_result {
    padding-top: 120px;
    position: relative;
    .circle_box {
      background: url(~@/assets/report2_imgs/icon_xxdl_orange.png) no-repeat
        center center;
      .topBox {
        height: 200px;
      }
      .middleBox {
        .norm_box {
          .norm {
            .score {
              background-color: #feae3b;
              color: #feae3b;
              font-size: 12px;
            }
          }
        }
        .norm_qinggan {
          transform: rotate(-90deg);
          .score {
            transform: rotate(90deg);
          }
        }
        .norm_renzhi {
          transform: rotate(-151deg);
          .score {
            transform: rotate(151deg);
          }
        }
        .norm_xingwei {
          transform: rotate(-30deg);
          .score {
            transform: rotate(28deg);
          }
        }
      }
      .bottomBox {
        padding-top: 34px;
        text-align: center;
        color: #fff;
        .title {
          line-height: 42px;
          margin-bottom: 15px;
          font-size: 30px;
        }
        .score {
          line-height: 28px;
          font-size: 20px;
        }
      }
    }
    .detail_box {
      line-height: 28px;
      color: #8a8a8a;
      font-size: 14px;
      position: absolute;
      .title {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        display: flex;
        align-items: center;
        margin-left: -10px;
        span {
          width: 6px;
          height: 6px;
          background-color: #feae3b;
          margin-right: 5px;
          border-radius: 2px;
        }
      }
      .score {
        color: #333;
        line-height: 20px;
        span {
          color: #333;
        }
      }
      .norm {
        span {
          color: #50cfb1;
        }
      }
    }
    .detail_box0 {
      left: 40px;
      top: 226px;
    }
    .detail_box1 {
      left: 325px;
      top: 11px;
    }
    .detail_box2 {
      left: 600px;
      top: 226px;
    }
    .detail_box3 {
      left: 300px;
      top: 280px;
      z-index: 3;
      text-align: center;
      .title {
        font-size: 16px;
        margin-left: 0;
        text-align: center;
        justify-content: center;
      }
    }
  }

  .page_part2_result .circle_box{
    position: relative;
    width: 410px;
    height: 410px;
    margin: 0 auto;
    background: url(~@/assets/report2_imgs/icon_xxdl.png) no-repeat center center;
    // background-size: 380px 380px;
  }
  .page_part2_result .detail_box1{
    top: 11px;
    left: 390px;
  }
  .page_part2_result .detail_box0{
    left: 136px;
    top: 180px;
}
.page_part2_result .detail_box2{
    left: 641px;
    top: 180px;
}


  .fenxi_box {
    padding: 35px 25px 25px 25px;
    background: #f6f6f6;
    border-radius: 6px;
    position: relative;
    margin-top: 60px;
    .f_title {
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 6px;
      text-align: center;
      font-size: 16px;
      position: absolute;
      left: 25px;
      top: -15px;
      color: #fff;
      font-weight: bold;
    }
    .main {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
      p {
        line-height: 25px;
        color: #969696;
        font-size: 14px;
      }
      .title {
        color: #303030;
        font-size: 16px;
      }
      .advise {
        padding-left: 10px;
        position: relative;
        margin-bottom: 10px;
        color: #333;
        &:before {
          content: "";
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background-color: #aacf00;
          top: 11px;
          left: 0;
        }
      }
    }
  }
  .lis_score_box {
    padding-bottom: 60px;
    .lis_score {
      li {
        display: flex;
        height: 50px;
        .name {
          padding-right: 16px;
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          line-height: 50px;
          border-right: 1px solid #e0dede;
          flex: 1;
        }
        .li_score_box {
          padding: 15px 0;
          height: 20px;
          width: 600px;
          .box {
            height: 20px;
            background-color: #f6f6f6;
            position: relative;
            .score_comment {
              position: absolute;
              top: 0;
              line-height: 20px;
              color: #fff;
              z-index: 10;
            }

            .comment {
              height: 20px;
              position: absolute;
              top: 0;
              line-height: 20px;
              color: #fff;
              z-index: 10;
              span {
                display: inline-block;
                margin-right: 15px;
                font-size: 14px;
                font-weight: bold;
              }
            }
            .score {
              text-align: right;
              height: 20px;
              line-height: 20px;
              box-sizing: border-box;
              padding-right: 5px;
              color: #fff;
              font-size: 14px;
              position: relative;
              p {
              }
            }
            .norm {
              position: absolute;
              height: 20px;
              top: 0;
              background: rgba(121, 119, 119, 0.55);
              opacity: 0.59;
            }
          }
        }
      }
    }
    .rule_box {
      display: flex;
      .name {
        flex: 1;
        height: 10px;
        border-right: 1px solid #e0dede;
        position: relative;
        span {
          position: absolute;
          width: 10px;
          height: 20px;
          line-height: 20px;
          right: -5px;
          bottom: -30px;
          font-size: 12px;
        }
      }
      .rule {
        width: 600px;
        display: flex;

        li {
          flex: 1;
          height: 10px;
          border-bottom: 1px solid #e0dede;
          border-right: 1px solid #e0dede;
          position: relative;
          span {
            position: absolute;
            width: 20px;
            height: 20px;
            line-height: 20px;
            right: -10px;
            bottom: -30px;
            font-size: 12px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
